
export enum UpdateValueFieldsScreen {
    "ADD_ITEMS" = "ADD_ITEMS",
    "SUBMIT_BID" = "SUBMIT_BID"
}
export type UpdateValueFields = {
    /**
     * @type integer int64
    */
    itemId: number;
    /**
     * @type string
    */
    screen: UpdateValueFieldsScreen;
    /**
     * @type object
    */
    bidFeatureValues: {
        [key: string]: string;
    };
};

import type { ValidationErrorResponse } from "./ValidationErrorResponse";
import type { ErrorResponse } from "./ErrorResponse";
import type { ResponseMapLongFieldsResponse } from "./ResponseMapLongFieldsResponse";

export type UpdateValueFieldsQueryParams = {
    /**
     * @type integer int64
    */
    tenderId: number;
};

/**
 * @description Bad Request
*/
export type UpdateValueFields400 = ValidationErrorResponse;

/**
 * @description Unauthorized
*/
export type UpdateValueFields401 = ErrorResponse;

/**
 * @description Forbidden
*/
export type UpdateValueFields403 = ErrorResponse;

/**
 * @description Unprocessable Entity
*/
export type UpdateValueFields422 = ValidationErrorResponse;

/**
 * @description Too Many Requests
*/
export type UpdateValueFields429 = ErrorResponse;

/**
 * @description Internal Server Error
*/
export type UpdateValueFields500 = ErrorResponse;

export type UpdateValueFieldsMutationRequest = UpdateValueFields;

/**
 * @description OK
*/
export type UpdateValueFieldsMutationResponse = ResponseMapLongFieldsResponse;
